import queryString from 'query-string';

import type { I18nFn } from '#/i18n/types/I18nFn';
import { LISTING_TYPE_HUMAN_NAME_MAP } from '#/utils/constants/general/listingTypeHumanNameMap';

export function getSocialLink(
  i18n: I18nFn,
  // oxlint-disable-next-line typescript/no-explicit-any
  socialType: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  link: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  message: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  listingType: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  subject: any,
): string {
  switch (socialType) {
    case 'facebook': {
      const qs = queryString.stringify({
        u: link,
        ...(message
          ? {
              title: message,
            }
          : {}),
      });
      return `https://facebook.com/sharer/sharer.php?${qs}`;
    }

    case 'x': {
      const qs = queryString.stringify({
        text: message,
        url: link,
      });
      return `https://x.com/intent/tweet/?${qs}`;
    }

    case 'email': {
      let body = i18n('Click the link below to see the page on Idealist:');

      if (message) {
        body = message;
      } else if (listingType === 'CMS_PAGE') {
        body = i18n('Click the link below to see the article on Idealist:');
      } else if (listingType === 'URL') {
        body = i18n('Click the link below to see the article from Idealist:');
      } else if (listingType) {
        i18n('Click the link below to see the %(type)s listing on Idealist:', {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          type: LISTING_TYPE_HUMAN_NAME_MAP(i18n)[listingType],
        });
      }

      const qs = queryString.stringify({
        subject,
        body: `${body}\n\n${link}`,
      });
      return `mailto:?${qs}`;
    }

    case 'linkedin': {
      const qs = queryString.stringify({
        url: link,
        mini: true,
        title: message,
      });
      return `https://www.linkedin.com/shareArticle?${qs}`;
    }

    default:
      throw new Error(`Invalid social type ${socialType}`);
  }
}
